import React, {Fragment, useEffect, useState} from 'react'
import {Description, Dialog, Disclosure, Field, Label, Menu, Switch, Transition} from '@headlessui/react'
import {Bars3Icon, BellIcon, XMarkIcon} from '@heroicons/react/24/outline'

import MainNavigation from "../../components/common/navigation.component";
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {
    addEventAttribute,
    adminEventCard,
    audienceButtons,
    getDefaultPerformer,
    getDefaultVenue,
    getLocalDate,
    getLocalDateForEvent,
    MetaTags,
    setDefaultPerformer,
    setDefaultVenue,
    setUniqueEventAttribute,
    smallArtistCard,
    smallEventCard,
    smallSchemaArtistCard,
    thumbnailPad,
    toastSuccess,
    workingWithCard
} from "../../components/common/utilities";
import {ChevronDownIcon, MagnifyingGlassIcon} from "@heroicons/react/20/solid";
import {ArrowLongLeftIcon, ArrowLongRightIcon, ChevronDoubleLeftIcon} from "@heroicons/react/16/solid";
import Searchsidebar from "../../components/search/searchsidebar";
import {ToastContainer} from "react-toastify";
import PromoteEvent from "../../components/common/promoteEvent";
import PromoteEventLoggedIn from "../../components/common/promoteEventLoggedIn";
import FindEvents from "../events/findEvents";

function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function Admarket() {
    const navigate = useNavigate();
    const logout = () => {
        window.location.href = '/logout';
    }

    let params = useParams();
    const venueID = params.venueID;
    const data = useLoaderData() as any;
    //console.log(data);

    const [events, setEvents] = useState([]);
    const [artistEvents, setArtistEvents] = useState([]);
    const [edp, setEDP] = useState([]);
    const [eventOffset, setEventOffset] = useState(0);
    const [eventLimit, setEventLimit] = useState(10);
    const [nextOffset, setNextOffset] = useState("");
    const [previousOffset, setPreviousOffset] = useState("");
    const [isEnd, setIsEnd] = useState(false);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [workingWith, setWorkingWith] = useState<SchemaArtist>();
    const [showConnector, setShowConnector] = useState(false);
    const [lang, setLang] = useState(getLang());
    const [showEventSearch, setShowEventSearch] = useState(true);

    type SchemaArtist = {
        [key: string]: any; // ?? variable key
        name: string;
    };
    const [artistData, setArtistData] = useState<SchemaArtist>();

    var date = new Date();
    const getEvents = nextOffset => {

        window.scrollTo(0, 0);
        setLoading(true);
        setEvents([]);

        let shouldfetch = false;

        let params = {
            limit: 48, country: "IS", offset: nextOffset, lang: "is", light: true,
        }

        if (getDefaultPerformer())
        {
            const performer = getDefaultPerformer();
            //console.log("performer",performer['@id'])
            setWorkingWith(performer);
            shouldfetch = true;
            params['artist'] = performer['@id'];
        }
        else if (getDefaultVenue())
        {
            shouldfetch = true;
            const venue = getDefaultVenue();
            //console.log("venue",venue['@id'])
            setWorkingWith(venue);
            shouldfetch = true;
            params['venue'] = venue['@id'];
        }
        if (!shouldfetch)
        {
            setLoading(false);
            return;
        }

        axios.get(`${process.env.REACT_APP_API_URL}/p/events/upcoming.do`, {
            params: params

        }).then(function (response) {
            // handle success
            console.log("events", response);
            setEvents(response.data.collection);
            setNextOffset(response.data.pagination.nextOffset);
            setPreviousOffset(response.data.pagination.previousOffset);
            setEventOffset(eventOffset + eventLimit);
            setLoading(false);
            if (response.data.pagination.end)
            {
                setIsEnd(true);
                setLoading(false);
            }

        }).catch(function (error) {
            // handle error
            console.log(error);
            setLoading(false);
        });
    }

    const getArtistEvents = (nextOffset, artistid) => {
        //window.scrollTo(0, 0);
        setArtistEvents([]);


        axios.get(`${process.env.REACT_APP_API_URL}/p/events/upcoming.do`, {
            params: {
                limit: 48, artist: artistid, offset: nextOffset, lang: "is", light: true,
            }

        }).then(function (response) {
            // handle success
            console.log("events", response);
            setArtistEvents(response.data.collection);

        });
    }

    const getMoreEvents = () => {
        getEvents(eventOffset);
    }

    function getLang()
    {
        const userlang = localStorage.getItem('userlang');
        if (userlang)
        {
            return userlang;
        }
        if (navigator.languages != undefined) return navigator.languages[0];
        return navigator.language;
    }

    const getEvent = ({eventID}) => {
        console.log("getEvent", eventID);
        const now = new Date();

        let parameters = {
            event: eventID, tiny: true, lang: lang,
        };
        if (data.isAdmin)
        {
            parameters['admin'] = true;
        }

        axios.get(`${process.env.REACT_APP_API_URL}/p/manage/event.do`, {
            params: parameters

        }).then(function (response) {
            // handle success
            //console.log(response);
            setArtistData(response.data)
            setOpen(true);

        }).catch(function (error) {
            // handle error
            console.log(error);
            //window.location.href = '/dashboard';
        });
    }

    useEffect(() => {

        getEvents("");
        if(data.performer || data.venue)
        {
            setShowEventSearch(false);
        }
        //getPhotos();

    }, []);

    function clickedEvent(e)
    {
        console.log("clicked", e.target);

        let button = e.target.dataset.button;
        if (button === 'setAd')
        {
            console.log('setAd');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event updated');

        }
        else if (button === 'setPrivate')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event set to private');

        }
        else if (button === 'viewEvent')
        {
            let eventid = e.target.dataset.eventid;
            /*
                        viewArtist(null,eventid);
            */
        }
        else if (button === 'setAttractionType')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Attraction Type set to ' + value);

        }

        else if (button === 'addAttribute')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = false;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            addEventAttribute(key, value, unique, eventid);

            toastSuccess('Attribute ' + key + ' set to ' + value);

        }

        else if (button === 'manageAudience')
        {
            console.log('managing audience');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = false;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            addEventAttribute('pgg.audience.' + key, 'pgg.audience.' + value, remove, eventid);

            toastSuccess('Audience set ' + key + ' Remove: ' + remove);

        }

        else if (button === 'workingWith')
        {
            let artistid = e.target.dataset.artistid;
            let venueid = e.target.dataset.venueid;
            if (artistid)
            {
                axios.get(`${process.env.REACT_APP_API_URL}/p/api/artist.do`, {
                    params: {
                        lang: "is", artist: artistid
                    }
                }).then(function (response) {
                    // handle success
                    setDefaultPerformer(response.data);
                    localStorage.removeItem('defaultVenue');
                    setEvents([]);
                    console.log("artist", response);
                    setWorkingWith(response.data);
                    setIsEnd(false);
                    getEvents(null);
                    setOpen(false);
                });
            }
            else if (venueid)
            {
                axios.get(`${process.env.REACT_APP_API_URL}/p/api/venue.do`, {
                    params: {
                        lang: "is", venue: venueid, light: true,
                    }
                }).then(function (response) {
                    // handle success
                    localStorage.removeItem('defaultPerformer');

                    setDefaultVenue(response.data);
                    setEvents([]);
                    console.log("venue", response);
                    setWorkingWith(response.data);
                    setIsEnd(false);
                    getEvents(null);
                    setOpen(false);
                });

            }

        }
        else if (button === 'editEvent')
        {
            let eventid = e.target.dataset.attractionid;
            getEvent({eventID: eventid});
        }


    }

    const viewArtist = (artist) => {
        setArtistData(artist);
        setShowConnector(false);
        setOpen(true);
        getArtistEvents("", artist['@id']);

    }

    const toggleConnector = () => {
        setShowConnector(true);
        setOpen(true);
        setArtistData(null);
    }

    const closeSidebar = () => {
        setOpen(false);
        setShowConnector(false);
        setArtistData(null)
    }


    return (<>
        <MetaTags
            title='Auglýstu!'
            description='Auglýstu viðburði á íslenskum miðlum'
            image='https://promogogo.com/cdn-cgi/image/fit=contain,width=768/https://media.promogogo.com/ymsirvidburdir/2024-06-10/3666078aaa094262b626960bf705498b.png'
            name='Team Mobilitus'
        />
        <div className="min-h-full dark:bg-white bg-white">
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-40" onClose={closeSidebar}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-2">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-4xl">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                                            <div
                                                className="flex min-h-0 flex-1 flex-col overflow-y-scroll overflow-x-hidden py-1">
                                                <div className="px-2 sm:px-6">
                                                    <div className="flex items-start justify-between">
                                                        <Dialog.Title
                                                            className="text-base font-semibold leading-6 text-gray-900">

                                                        </Dialog.Title>
                                                        <div className="ml-3 flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="relative rounded-md bg-red-700 text-white hover:bg-red-500 hover:outline-none hover:ring-2 hobver:ring-red-500"
                                                                onClick={() => setOpen(false)}
                                                            >
                                                                <span className="absolute -inset-2.5"/>
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                                    {showConnector && <>
                                                        <div className={'text-2xl font-semibold text-gray-900 mt-2'}>Auglýsa
                                                            fyrir
                                                        </div>
                                                        <div onClick={(event) => clickedEvent(event)}>
                                                            <Searchsidebar buttontype={'workingWith'}
                                                                           initialQuery={data.name}/>
                                                        </div>
                                                    </>}

                                                    {artistData && <div>
                                                        {artistData && artistData.name &&
                                                         <div className="px-4 py-5 sm:p-6"
                                                              onClick={(event) => clickedEvent(event)}>
                                                             {smallEventCard(artistData)}
                                                         </div>}
                                                        {!artistData &&
                                                         <div className="p-4 text-gray-800 flex justify-center">
                                                             <div className={'text-pg_yellow'}><i
                                                                     className="fa-2x fa-duotone fa-loader fa-spin"></i>
                                                             </div>
                                                         </div>}
                                                        {artistData && <>
                                                            <PromoteEventLoggedIn event={artistData}/>
                                                        </>}

                                                        {artistEvents.length > 0 &&
                                                         <h5 className="text-md font-semibold text-gray-900 mt-4">Events</h5>}
                                                        {artistEvents.length > 0 && artistEvents.map((event) => (
                                                            <div className="px-4 py-5 sm:p-6"
                                                                 key={'artistevent' + event['@id']}>
                                                                {smallEventCard(event)}
                                                            </div>))}
                                                    </div>}

                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                                                    onClick={() => closeSidebar()}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
            <SidebarNavigation/>
            <div className="lg:pl-72">
                <div className="mx-auto max-w-7xl px-6 py-6 sm:py-12 lg:px-8">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                        Auglýstu viðburði
                    </h2>
                    <div className="mt-2">
                        <Field className="flex items-center justify-between mb-2">
      <span className="flex grow flex-col">
        <Label as="span" passive className="text-sm/6 font-medium text-gray-900">
          Show Event Search
        </Label>
        <Description as="span" className="text-sm text-gray-500">
          Or browse by artist or venue
        </Description>
      </span>
                            <Switch
                                checked={showEventSearch}
                                onChange={setShowEventSearch}
                                className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                            >
        <span
            aria-hidden="true"
            className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
        />
                            </Switch>
                        </Field>
                        {!showEventSearch && workingWith && <div><h5 className={'text-sm font-medium'}>Fyrir</h5>
                            <div
                                    key={workingWith['@id']}
                                    className="max-w-2xl mt-2 relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"
                                    onClick={() => toggleConnector()}

                            >
                                <div className="flex-shrink-0">
                                    {workingWith.image && (
                                        <img className="h-20 w-30 flex-shrink-0 rounded-l bg-gray-300"
                                             src={workingWith.image} alt=""/>)}
                                    {!workingWith.image && (
                                        <div className="h-10 w-16 flex-shrink-0 rounded-full bg-gray-300"/>)}
                                </div>
                                <div className="min-w-0 flex-1 pt-2 pb-2">
                                    <a href="#" className="focus:outline-none">
                                        <span className="absolute inset-0" aria-hidden="true"/>
                                        <p className="text-sm font-medium text-gray-900">{workingWith.name}</p>
                                        <p className="truncate text-sm text-gray-500"></p>
                                    </a>
                                </div>
                            </div>
                            <div className={'text-sm font-semibold text-gray-900 mt-2 cursor-pointer hover:text-indigo-500'}
                                 onClick={() => toggleConnector()}>Skiptu um auglýsanda
                            </div>
                            <div className={'text-sm text-gray-900 mt-2'}
                            >Þetta fer á reikning {data.name}</div>
                        </div>}
                        {!showEventSearch && !workingWith && <div><h5 className={'text-sm font-medium'}>Fyrir</h5>
                            <div

                                    className="max-w-2xl mt-2 relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"
                                    onClick={() => setOpen(true)}

                            >
                                <div className="flex-shrink-0">

                                    <div className="h-10 w-16 flex-shrink-0 rounded-full bg-gray-300"/>
                                </div>
                                <div className="min-w-0 flex-1 pt-2 pb-2">
                                    <a href="#" className="focus:outline-none">
                                        <span className="absolute inset-0" aria-hidden="true"/>
                                        <p className="text-sm font-medium text-gray-900">Hvern á að auglýsa?</p>
                                        <p className="truncate text-sm text-gray-500">Veldu þann sem kemur fram og síðan
                                            viðburðina.</p>
                                    </a>
                                </div>
                            </div>

                        </div>}
                    </div>
                </div>
                <main className="p-1">
                    {!showEventSearch && <>
                    {events && events.length > 0 &&
                     <nav className="sticky bg-white z-30 flex items-center justify-between px-4 sm:px-0  mt-2 mb-2"
                          style={{top: "60px"}}>
                         <div className="-mt-px flex w-0 flex-1">
                             <div
                                     onClick={() => getEvents(0)}
                                     className="cursor-pointer inline-flex items-center border-b-2 border-transparent pr-1 pb-2 pt-2 text-sm font-medium text-gray-500 hover:border-blue-500 hover:text-gray-700"
                             >
                                 <ChevronDoubleLeftIcon className="mr-3 h-5 w-5 text-green-800" aria-hidden="true"/>

                             </div>
                         </div>
                         <div className="-mt-px md:flex">
                             <div
                                     onClick={() => getEvents(previousOffset)}
                                     className="cursor-pointer inline-flex items-center border-b-2 border-transparent pr-1 pb-2 pt-2 text-sm font-medium text-gray-500 hover:border-blue-500 hover:text-gray-700"
                             >
                                 <ArrowLongLeftIcon className="mr-3 h-5 w-5 text-green-800" aria-hidden="true"/>

                             </div>
                             <div
                                     onClick={() => getEvents(nextOffset)}
                                     className="cursor-pointer inline-flex items-center border-b-2 border-transparent pl-1 pb-2 pt-2 text-sm font-medium text-gray-500 hover:border-blue-500 hover:text-gray-700"
                             >

                                 <ArrowLongRightIcon className="ml-3 h-5 w-5 text-green-800" aria-hidden="true"/>
                             </div>

                         </div>
                         <div className="-mt-px flex w-0 flex-1 ">

                         </div>
                     </nav>}
                        <ul role="list"
                            className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-4 xl:grid-cols-5 xl:gap-x-8">
                            {events.map((artist) => (
                                <li key={artist['@id']} className="relative" onClick={(e) => viewArtist(artist)}>
                                    <div
                                        className="group aspect-[16/9] block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100">
                                        {artist.image && thumbnailPad(artist.image)}
                                        <button type="button" className="absolute inset-0 focus:outline-none">
                                            <span className="sr-only">View details for {artist.name}</span>
                                        </button>
                                    </div>
                                    <div
                                        className={'text-md font-semibold text-gray-900 mt-2'}>{artist.name}</div>

                                    <div
                                        className={'text-sm font-semibold text-gray-900 mt-2'}>{artist.gogo && artist.gogo.wholeday && getLocalDateForEvent(artist, artist.localStartDate, artist.timezone)}{artist.gogo && !artist.gogo.wholeday && getLocalDateForEvent(artist, artist.localStartDate, artist.timezone)} @ {artist.location && artist.location.name}</div>
                                </li>))}

                        </ul>
                    {loading && <div className="p-4 text-gray-800 flex justify-center">
                        <div className={'text-pg_yellow'}><i
                                className="fa-2x fa-duotone fa-loader fa-spin"></i></div>
                    </div>}
                    </>}
                    {showEventSearch && <div className="mt-2" onClick={(event) => clickedEvent(event)}>
                        <FindEvents eventData={null} limit={20} merge={false}/>
                    </div>}


                </main>
            </div>
            <ToastContainer autoClose={800} theme={'dark'}/>
        </div>


    </>)
}
